import {configureStore} from "@reduxjs/toolkit";
import postReducer from '../redux/post'
import homeReducer from '../redux/home'
import aboutReducer from '../redux/about'
import contactReducer from '../redux/contact'
import projectReducer from '../redux/project'
import equipmentReducer from '../redux/equipment'
import globalReducer from '../redux/global'
import footerReducer from '../redux/footer'

const store = configureStore({
    reducer: {
        globalReducer,
        posts: postReducer,
        home: homeReducer,
        about: aboutReducer,
        contact: contactReducer,
        equipment: equipmentReducer,
        project: projectReducer,
        footer:  footerReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})

export default store

